export const loginEndpoint = '/api/user/token/login';
export const updatePasswordEndpoint = '/api/user/users/set_password';
